import MainLayout from "@/layouts/MainLayout";
import { FileText, Copy } from "lucide-react";
import { useState } from "react";

const files = [
  {
    name: "Prompt Engineer System Prompt (Markdown)",
    path: "/resources/prompt-engineer-system-prompt.md"
  },
  {
    name: "Prompt Engineering by Lee Boonstra (Markdown)",
    path: "/resources/Prompt-Engineering-by-Lee-Boonstra.md"
  },
  {
    name: "Practical Takeaways for Better Prompt Engineering (Markdown)",
    path: "/resources/Practical-Takeaways-for-Better-Prompt-En.md"
  },
  {
    name: "A Systematic Survey of Prompt Engineering (PDF)",
    path: "/resources/a-systematic-survey-of-prompt-engineering.pdf"
  },
  {
    name: "Prompt Engineering by Lee Boonstra (PDF)",
    path: "/resources/prompt-engineering-by-lee-boonstra.pdf"
  }
];

const menuButtonClass =
  "inline-flex h-10 items-center justify-center rounded-full bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-[rgba(245,112,170,0.94)] hover:text-white focus:bg-[rgba(245,112,170,0.94)] focus:text-white focus:outline-none disabled:pointer-events-none disabled:opacity-50 border border-primary text-primary";
const menuButtonPrimaryClass =
  "inline-flex h-10 items-center justify-center rounded-full bg-primary px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-[rgba(245,112,170,0.94)] focus:bg-[rgba(245,112,170,0.94)] focus:outline-none disabled:pointer-events-none disabled:opacity-50";

const DownloadsPage = () => {
  const [copiedIndex, setCopiedIndex] = useState<number | null>(null);

  const handleCopy = (url: string, idx: number) => {
    navigator.clipboard.writeText(window.location.origin + url);
    setCopiedIndex(idx);
    setTimeout(() => setCopiedIndex(null), 1500);
  };

  return (
    <MainLayout
      title="AI Resources & Templates | Niumora Downloads"
      description="Download our comprehensive collection of AI resources, guides, templates, and tools to help you implement AI solutions in your business. Get instant access to our curated library of practical AI resources."
      keywords="AI downloads, AI resources, AI templates, business automation guides, AI implementation tools, Niumora resources, AI for business"
      ogType="website"
    >
      <div className="py-24 container max-w-3xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
            <FileText className="h-6 w-6" />
          </div>
          <div>
            <h1 className="text-3xl font-bold">Downloads</h1>
            <p className="text-muted-foreground">Access our collection of downloadable resources</p>
          </div>
        </div>
        <div className="space-y-4">
          {files.map((file, idx) => (
            <div key={file.path} className="flex items-center justify-between p-4 border rounded">
              <span>{file.name}</span>
              <div className="flex gap-2">
                <a
                  href={file.path}
                  download
                  className={menuButtonPrimaryClass}
                >
                  Download
                </a>
                <button
                  className={menuButtonClass + " flex items-center gap-1"}
                  onClick={() => handleCopy(file.path, idx)}
                  type="button"
                >
                  <Copy className="h-4 w-4" />
                  {copiedIndex === idx ? "Copied!" : "Copy Link"}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </MainLayout>
  );
};

export default DownloadsPage; 